/* NANIMERICA · Worn by creators (sections/nr-home-creators.liquid + snippets/nr-worn-by.liquid) */
(function () {
function initCreators(root) {
  if (!root || root.nrcrReady) return;
  root.nrcrReady = true;
  if (root.hasAttribute('data-line') && document.querySelector('[data-line]') !== root) { root.remove(); return; }
  var track = root.querySelector('[data-track]');
  var cards = Array.prototype.slice.call(track.querySelectorAll('[data-card]'));
  var max = parseInt(root.getAttribute('data-max'), 10) || cards.length;
  var cur = root.getAttribute('data-current');
  var line = root.hasAttribute('data-line');

  /* Order: this product's reels, then pinned (by Order), then the rest shuffled */
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  var mine = [], pinned = [], rest = [];
  cards.forEach(function (c) {
    if (cur && c.getAttribute('data-products').indexOf('|' + cur + '|') > -1) mine.push(c);
    else if (c.getAttribute('data-pinned') === '1') pinned.push(c);
    else rest.push(c);
  });
  var byOrder = function (a, b) { return (+a.getAttribute('data-order')) - (+b.getAttribute('data-order')); };
  mine.sort(byOrder); pinned.sort(byOrder);
  cards = mine.concat(pinned, shuffle(rest)).slice(0, max);
  track.innerHTML = '';
  cards.forEach(function (c) { track.appendChild(c); });
  /* Start the row at the first card (scroll-snap otherwise keeps the pre-sort card in view) */
  var touched = false;
  ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) { track.addEventListener(ev, function () { touched = true; }, { passive: true }); });
  function toStart() { if (!touched) track.scrollLeft = 0; }
  toStart(); requestAnimationFrame(toStart); setTimeout(toStart, 400);
  if (document.readyState !== 'complete') window.addEventListener('load', toStart, { once: true });

  /* Combined reach */
  var reach = root.querySelector('[data-reach]');
  if (reach && !line) {
    var total = 0;
    cards.forEach(function (c) {
      var m = (c.getAttribute('data-followers') || '').replace(/,/g, '').match(/([\d.]+)\s*([kKmM]?)/);
      if (!m) return;
      var n = parseFloat(m[1]); var u = m[2].toLowerCase();
      total += u === 'm' ? n * 1e6 : u === 'k' ? n * 1e3 : n;
    });
    if (total >= 1e5) {
      var label = total >= 1e6 ? (Math.floor(total / 1e5) / 10) + 'M+' : Math.floor(total / 1e3) + 'K+';
      reach.querySelector('[data-reach-n]').textContent = label;
      reach.hidden = false;
    }
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function startCard(c) {
if (!c.getAttribute('data-card-src')) return; /* no preview clip (e.g. the "Also worn by" strip): load nothing until tapped */
    var v = c.querySelector('video');
    if (!v.src) v.src = c.getAttribute('data-card-src');
    var p = v.play();
    if (p && p.then) p.then(function () { c.classList.add('is-playing'); }).catch(function () {});
    else c.classList.add('is-playing');
  }
  function stopCard(c, reset) {
    var v = c.querySelector('video');
    if (!v) return;
    v.pause();
    c.classList.remove('is-playing');
    if (reset) v.currentTime = 0;
  }

  /* First card previews (muted) while the row is on screen */
  var lead = line ? null : cards[0];
  if (lead && !reduce && !saveData && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (dlg.open) return;
        if (e.isIntersecting) startCard(lead); else stopCard(lead);
      });
    }, { threshold: 0.6 }).observe(lead);
  }
  /* Desktop: hover previews */
  if (!line && window.matchMedia('(hover: hover)').matches && !reduce) {
    cards.forEach(function (c) {
      if (c === lead) return;
      c.addEventListener('mouseenter', function () { startCard(c); });
      c.addEventListener('mouseleave', function () { stopCard(c, true); });
    });
  }

  /* Viewer */
  var dlg = root.querySelector('dialog');
  var vid = dlg.querySelector('[data-vid]');
  var bars = dlg.querySelector('[data-bars]');
  var chips = dlg.querySelector('[data-chips]');
  var shopK = dlg.querySelector('[data-shop-k]');
  var all = dlg.querySelector('[data-all]');
  var idx = 0, muted = false, clipS = 0, clipE = 0, ending = false;
  bars.innerHTML = cards.map(function () { return '<span class="nrcr-v__bar"><i></i></span>'; }).join('');
  var barEls = bars.querySelectorAll('.nrcr-v__bar');

  function setMute(m) { muted = m; vid.muted = m; dlg.classList.toggle('is-muted', m); dlg.querySelector('[data-mute]').setAttribute('aria-label', m ? 'Unmute' : 'Mute'); }
  function show(i) {
    idx = i;
    var c = cards[i];
    barEls.forEach(function (b, j) { b.classList.toggle('is-done', j < i); b.querySelector('i').style.width = j < i ? '100%' : '0'; });
    dlg.querySelector('[data-v-name]').textContent = c.getAttribute('data-name');
    dlg.querySelector('[data-v-meta]').textContent = [c.getAttribute('data-followers') ? c.getAttribute('data-followers') + ' followers' : '', c.getAttribute('data-meta')].filter(Boolean).join(' · ');
    var tpl = c.querySelector('template[data-shop]');
    chips.innerHTML = tpl ? tpl.innerHTML : '';
    var has = chips.children.length > 0;
    chips.hidden = !has; shopK.hidden = !has;
    all.classList.toggle('nrcr-v__all--solo', !has);
    dlg.querySelectorAll('[data-prev]').forEach(function (b) { b.disabled = i === 0; });
    dlg.querySelectorAll('[data-next]').forEach(function (b) { b.disabled = false; });
    clipS = parseFloat(c.getAttribute('data-clip-start')) || 0;
    clipE = parseFloat(c.getAttribute('data-clip-end')) || 0;
    ending = false;
    vid.src = c.getAttribute('data-full-src') + (clipS || clipE ? '#t=' + clipS + (clipE ? ',' + clipE : '') : '');
    vid.poster = (c.querySelector('img') || {}).currentSrc || '';
    vid.muted = muted;
    var p = vid.play();
    if (p && p.catch) p.catch(function () { setMute(true); vid.play().catch(function () {}); });
  }
  var stage = dlg.querySelector('[data-stage]');
  function guard() { if (stage.nrSkip) { stage.nrSkip = false; return true; } return false; }
  function next() { if (idx < cards.length - 1) show(idx + 1); else close(); }
  function prev() { if (idx > 0) show(idx - 1); else { vid.currentTime = clipS; if (vid.paused) vid.play().catch(function () {}); } }
  function open(i) {
    cards.forEach(function (c) { stopCard(c); });
    setMute(false);
    document.documentElement.classList.add('nrcr-lock');
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    show(i);
  }
  function close() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    vid.pause(); vid.removeAttribute('src'); vid.load();
    document.documentElement.classList.remove('nrcr-lock');
    if (lead && !reduce && !saveData) { var r = lead.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) startCard(lead); }
  });
  vid.addEventListener('loadedmetadata', function () { if (clipS && vid.currentTime < clipS - 0.25) vid.currentTime = clipS; });
  vid.addEventListener('timeupdate', function () {
    if (!vid.duration) return;
    var end = clipE && clipE < vid.duration ? clipE : vid.duration;
    var pct = Math.max(0, Math.min(1, (vid.currentTime - clipS) / (end - clipS)));
    barEls[idx].querySelector('i').style.width = (pct * 100) + '%';
    if (clipE && vid.currentTime >= clipE - 0.05 && !ending) { ending = true; vid.pause(); next(); }
  });
  vid.addEventListener('ended', next);
  cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
  root.querySelectorAll('[data-open]').forEach(function (b) { b.addEventListener('click', function () { open(0); }); });
  dlg.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { if (!guard()) next(); }); });
  dlg.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { if (!guard()) prev(); }); });
  dlg.querySelector('[data-close]').addEventListener('click', close);
  dlg.querySelector('[data-mute]').addEventListener('click', function () { setMute(!muted); if (vid.paused) vid.play().catch(function () {}); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    if (e.key === ' ' && e.target === dlg) { e.preventDefault(); vid.paused ? vid.play() : vid.pause(); }
  });
  /* Swipe: left/right to change, down to close */
  var sx = 0, sy = 0;
  stage.addEventListener('touchstart', function (e) { sx = e.target.closest('.nrcr-v__shop') ? null : e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { stage.nrSkip = true; setTimeout(function () { stage.nrSkip = false; }, 400); dx < 0 ? next() : prev(); }
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { stage.nrSkip = true; close(); }
  }, { passive: true });
  /* Hold to pause */
  stage.addEventListener('pointerdown', function (e) { if (e.target.closest('a,button:not([data-prev]):not([data-next])')) return; stage.nrHold = setTimeout(function () { vid.pause(); stage.nrHeld = true; }, 220); });
  stage.addEventListener('pointerup', function () { clearTimeout(stage.nrHold); if (stage.nrHeld) { stage.nrHeld = false; stage.nrSkip = true; setTimeout(function () { stage.nrSkip = false; }, 400); vid.play().catch(function () {}); } });
}
function all(scope) { (scope || document).querySelectorAll('[data-nrcr]').forEach(initCreators); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
